import React from "react";
import { connect } from "react-redux";
import { Store } from "redux";
import { createReduxStore } from "../redux/reduxHelpers";
import { TICKETING_VIEWS } from "./reducers/ticketing";
import { Provider } from "react-redux";
import { reducers } from "./reducers/reducers";
import WorkerInboxContainer from "./WorkerInboxContainer";
import InboxItem from "./InboxItem";
import TicketingNavigation from "./TicketingNavigation";
import TicketList from "./TicketList";
import * as Auth from "../../lib/Auth";
import { USER_TAGS } from "../../lib/CommonTags.generated";
import type { ReduxState } from "./reducers/reducers";

type TicketingViewsProps = {
    selected_view?: keyof typeof TICKETING_VIEWS;
    is_kiosk: boolean;
};
type TicketingViewsState = {};

class TicketingViews extends React.Component<TicketingViewsProps, TicketingViewsState> {
    render() {
        const { selected_view } = this.props;
        switch (selected_view) {
            case TICKETING_VIEWS.tickets:
                return <TicketList />;
            case TICKETING_VIEWS.inbox:
                return <WorkerInboxContainer />;
            case TICKETING_VIEWS.inbox_item:
                return <InboxItem is_kiosk={this.props.is_kiosk} />;
            default:
                return null;
        }
    }
}

const mapStateToProps = (state: ReduxState) => ({ selected_view: state.ticketing.selected_view });

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const ConnectedTicketingViews = connect<PropsFromRedux, {}, {}, ReduxState>(mapStateToProps)(TicketingViews);

type TicketingAppProps = {};
type TicketingAppState = {};

export default class TicketingApp extends React.Component<TicketingAppProps, TicketingAppState> {
    store: Store<ReduxState>;
    is_kiosk: boolean = Auth.getUserTag(USER_TAGS.kiosk) === "true";

    constructor(props: TicketingAppProps) {
        super(props);
        this.store = createReduxStore(reducers);
    }

    render() {
        if (!this.store) {
            return null;
        }

        return (
            <Provider store={this.store}>
                <div className="ticketing">
                    {/* TOTEST: removed reduxDispatch props as they are already in connect */}
                    <TicketingNavigation is_kiosk={this.is_kiosk} />
                    <ConnectedTicketingViews is_kiosk={this.is_kiosk} />
                </div>
            </Provider>
        );
    }
}
